// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"file-export"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M20 11V7L15 2H4V22H10M14 2V8H20","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M19.0419 22.502L22.5021 19.0019L19.0419 15.502M21.3 19.002H13.998","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FileExportIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'file-export',
    ref,
    icon: element,
  },
));

FileExportIcon.displayName = 'FileExportIcon';

export default FileExportIcon;
